import React, { useState } from 'react';
import { Container, Row, Col, Nav, Form, Button, Tab } from 'react-bootstrap';
import DirectionsIcon from '@mui/icons-material/Directions';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import FavoriteIcon from '@mui/icons-material/Favorite';

const ListingContactAgent = () => {
    const [activeKey, setActiveKey] = useState('schedule');
    const [selectedDate, setSelectedDate] = useState(null);

    const dates = [
        { day: 'Sun', date: '18 May' },
        { day: 'Mon', date: '19 May' },
        { day: 'Tue', date: '20 May' },
        { day: 'Wed', date: '21 May' },
        { day: 'Thu', date: '22 May' },
        { day: 'Fri', date: '23 May' },
        { day: 'Sat', date: '24 May' }
    ];

    return (
        <Container className="mb-3">
            <h3>Learn More & Visit This Property</h3>
            <Row>
                <Col md={6} className="d-flex flex-column bg-light p-0" style={{ height: '100%' }}>
                    <div style={{ height: '50%', overflow: 'hidden' }}>
                        <img
                            src="https://ssl.cdn-redfin.com/photo/68/bigphoto/914/12364914_0.jpg"
                            alt="Request Tour"
                            className="w-100 h-100 object-fit-cover"
                        />
                    </div>
                    
                    <div className="d-flex flex-column justify-content-center p-4" style={{ height: '50%' }}>
                        <h2>$299,900</h2>
                        <h4>605 Keep Ave, Elgin, IL 60120</h4>
                        <Row >
                            <Col lg={3}>
                            4 Bed
                            </Col>
                            <Col lg={3}>
                            2.5 Bath
                            </Col>
                            <Col lg={3}>
                            2,298 sq/ft
                            </Col>
                        </Row>


                    </div>
                </Col>

                <Col md={6} className="p-4 border">
                    <Tab.Container activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
                        <Nav variant="tabs" className="mb-3">
                            <Nav.Item>
                                <Nav.Link eventKey="schedule">Schedule Tour</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="request">Ask Question</Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <Tab.Content>
                            <Tab.Pane eventKey="schedule">
                                <div className="d-flex overflow-auto mb-3 pb-3">
                                    {dates.map((d, idx) => (
                                        <Button
                                            key={idx}
                                            variant={selectedDate === idx ? 'primary' : 'outline-secondary'}
                                            className="me-2"
                                            onClick={() => setSelectedDate(idx)}
                                        >
                                            <div>{d.day}</div>
                                            <div>{d.date}</div>
                                        </Button>
                                    ))}
                                </div>
                                <Form>
                                    <Form.Group controlId="time">
                                        <Form.Label>Time</Form.Label>
                                        <Form.Control as="select" defaultValue="6:30 PM">
                                            <option>5:00 PM</option>
                                            <option>6:00 PM</option>
                                            <option>6:30 PM</option>
                                            <option>7:00 PM</option>
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group controlId="name" className="mt-3">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control type="text" placeholder="Your name" />
                                    </Form.Group>
                                    <Form.Group controlId="phone" className="mt-3">
                                        <Form.Label>Phone</Form.Label>
                                        <Form.Control type="tel" placeholder="Your phone number" />
                                    </Form.Group>
                                    <Form.Group controlId="email" className="mt-3">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="email" placeholder="Your email address" />
                                    </Form.Group>
                                    <Form.Check type="checkbox" label="I want to talk about financing" className="mt-3" />
                                    <Button variant="danger" type="submit" className="mt-3 w-100">
                                        Schedule Tour
                                    </Button>
                                </Form>
                            </Tab.Pane>

                            <Tab.Pane eventKey="request">
                                <Form>
                                    <Form.Group controlId="name">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control type="text" placeholder="Your name" />
                                    </Form.Group>
                                    <Form.Group controlId="phone" className="mt-3">
                                        <Form.Label>Phone</Form.Label>
                                        <Form.Control type="tel" placeholder="Your phone number" />
                                    </Form.Group>
                                    <Form.Group controlId="email" className="mt-3">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="email" placeholder="Your email address" />
                                    </Form.Group>
                                    <Button variant="danger" type="submit" className="mt-3 w-100">
                                        Request Info
                                    </Button>
                                </Form>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </Col>
            </Row>
        </Container>
    );
};

export default ListingContactAgent;